export const UserAdminRole = 'UserAdmin';
export const SubAdminRole = 'SubAdmin';
export const ClientAdminRole = 'ClientAdmin';
export const EE123Role = 'EE123.edit';
export const EE123SalariesRole_Edit = 'EE123Salaries.edit';
export const EE123SalariesRole_View = 'EE123Salaries.view';
export const EE123PeopleRole_Edit = 'EE123People.edit';
export const EE123PeopleRole_View = 'EE123People.view';
export const BEE123SalariesEditRole = 'TrainingRelatedSalaries.edit';
export const BEE123SalariesViewRole = 'TrainingRelatedSalaries.view';
export const AuditRole = 'Audit';
export const ClientRole = 'Client';
export const UserRole = 'User';
export const SiteAdminRole = 'SiteAdministration';
export const ScorecardAdmin = 'ScorecardAdmin';
export const PeopleViewRole = 'People.view';
export const PeopleEditRole = 'People.edit';
export const PlatformPeopleViewRole = 'PlatformPeople.view';
export const PlatformPeopleEditRole = 'PlatformPeople.edit';
export const PlatformPeopleSalaryViewRole = 'PlatformPeopleSalary.view';
export const PlatformPeopleSalaryEditRole = 'PlatformPeopleSalary.edit';
export const BEEAdvisoryRole = 'BEEAdvisory';
export const EEAdvisoryRole = 'EEAdvisory';
export const AdvancedSupplierModuleRole = 'AdvancedSupplierModule';
export const StrategicRelationshipManagerRole = 'StrategicRelationshipManager';
export const DataSupportRole = 'DataSupport';
export const ProjectsRole = 'Projects';
export const BEELockScorecards = 'LockScorecards.edit';
export const VAExportEditRole = 'VAExport.edit';
export const VAUser = 'VAUser';

